import React from "react";
import { useParams } from "react-router-dom";
import BasicDetails from "./BasicDetails";
import SmtpDetails from "./SmtpDetails";
import FrnDetails from "./FrnDetails";
import {
  CompanyDetailsSectionKey,
  DEFAULT_COMPANY_DETAILS_SECTION,
  isCompanyDetailsSectionKey,
} from "./sections";

// The Basic Details / Communication Credentials choice used to be a Fluent
// TabList here. Per the mockup it now lives in the System Manager sidebar, so
// this component only resolves the route's :section and renders it.
//
// An unknown or absent :section falls back to Basic Details rather than
// rendering nothing, so /system-manager/company-details and any stale link
// still land somewhere useful.

const SECTION_COMPONENTS: Record<CompanyDetailsSectionKey, React.ComponentType> =
  {
    "basic-details": BasicDetails,
    "communication-credentials": SmtpDetails,
    "frn-details": FrnDetails,
  };

function CompanyDetails() {
  const { section } = useParams();

  const activeSection: CompanyDetailsSectionKey = isCompanyDetailsSectionKey(
    section
  )
    ? section
    : DEFAULT_COMPANY_DETAILS_SECTION;

  const ActiveComponent = SECTION_COMPONENTS[activeSection];
  return (
    <div>
      <ActiveComponent />
    </div>
  );
}

export default CompanyDetails;
